import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 no-underline mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-vip-crown-line text-background-50 text-lg"></i>
                </span>
                <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                  国产一区
                </span>
              </Link>
              <p className="text-secondary-300 text-sm leading-relaxed">
                国产一区精选内容聚合平台，汇聚海量优质国产原创内容，精心分类整理，为用户提供流畅、清晰、丰富的一站式浏览体验。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-heading text-base mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-heading text-base mb-4">更多分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-heading text-base mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/about"
                  className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                >
                  品牌介绍
                </Link>
                <Link
                  to="/about"
                  className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                >
                  平台信誉
                </Link>
                <Link
                  to="/about"
                  className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                >
                  联系我们
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-secondary-400 text-sm">
              &copy; {new Date().getFullYear()} 国产一区精选内容聚合平台 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-secondary-400 hover:text-primary-400 text-sm transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-secondary-400 hover:text-primary-400 text-sm transition-colors" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}